import Select from 'react-select'
import createSelect from './createSelect'

export default createSelect(Select)
